module.exports = __webpack_public_path__ + "static/media/dd16a5e9-1741075352317_1741074703096.e136cab2.jpeg";